import script from "./ScaleCalibrationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ScaleCalibrationView.vue?vue&type=script&setup=true&lang=js"

import "./ScaleCalibrationView.vue?vue&type=style&index=0&id=27303797&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27303797"]])

export default __exports__